import { BaseEnum } from './BaseEnum';

export class TOCHandoffStatus extends BaseEnum {
  static WITHDREW = 'WITHDREW';
}

export default TOCHandoffStatus;
